/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrderStatisticsWarehouseOption
 */
export interface OrderStatisticsWarehouseOption {
    /**
     * 仓库ID
     * @type {number}
     * @memberof OrderStatisticsWarehouseOption
     */
    id?: number;
    /**
     * 仓库名称
     * @type {string}
     * @memberof OrderStatisticsWarehouseOption
     */
    name?: string;
}

/**
 * Check if a given object implements the OrderStatisticsWarehouseOption interface.
 */
export function instanceOfOrderStatisticsWarehouseOption(value: object): value is OrderStatisticsWarehouseOption {
    return true;
}

export function OrderStatisticsWarehouseOptionFromJSON(json: any): OrderStatisticsWarehouseOption {
    return OrderStatisticsWarehouseOptionFromJSONTyped(json, false);
}

export function OrderStatisticsWarehouseOptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderStatisticsWarehouseOption {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function OrderStatisticsWarehouseOptionToJSON(json: any): OrderStatisticsWarehouseOption {
    return OrderStatisticsWarehouseOptionToJSONTyped(json, false);
}

export function OrderStatisticsWarehouseOptionToJSONTyped(value?: OrderStatisticsWarehouseOption | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

